import React, { Component } from 'react';
import _ from 'lodash';
import ReactDataGrid from 'react-data-grid';
import { Field } from 'redux-form';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import PercentFormatter from '../Common/percentFormatter';
import { Selection } from '../Common/selection';
import Spinner from '../../components/Widgets/spinner';
import { UI_HEIGHT } from '../Common/constants';

import { ROOT_URL, isARC, isGFD, isCTP } from '../../actions/root_url';

const getBsStyle = (input, value) => (input === value ? 'success' : 'primary');

const renderRadios = (props) => {
  const renderStartDatePicker = (days) => {
    if (days === '-1') {
      return (
        <Button bsStyle="primary">
          <Field name="FromDate" placeholder="Start" component={DatePicker} />
        </Button>
      );
    }
    return (
      <Button bsStyle="primary">
        <Field name="FromDate" placeholder="Start" component={DisabledDatePicker} />
      </Button>
    );
  };
  const renderEndDatePicker = (days) => {
    if (days === '-1') {
      return (
        <Button bsStyle="primary">
          <Field name="ToDate" placeholder="End" component={DatePicker} />
        </Button>
      );
    }
    return (
      <Button bsStyle="primary">
        <Field name="ToDate" placeholder="End" component={DisabledDatePicker} />
      </Button>
    );
  };
  return (
    <ButtonToolbar className="radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, '1')}>
        <div className="radio">
          <label htmlFor="today-radio-filter">
            <input {...props.input} id="today-radio-filter" type="radio" onClick={()=>{props.fetchPosCreditsByDetails("1");}} name="dateFilterRadios" value="1" checked={props.input.value === '1'} />
            <Translate value="today" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '7')}>
        <div className="radio">
          <label htmlFor="sevenDay-radio-filter">
            <input {...props.input} id="sevenDay-radio-filter" type="radio" onClick={()=>{props.fetchPosCreditsByDetails("7");}} name="dateFilterRadios" value="7" checked={props.input.value === '7'} />
            <span>7 <Translate value="days" /></span>
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '30')}>
        <div className="radio">
          <label htmlFor="thirtyDay-radio-filter">
            <input {...props.input} id="thirtyDay-radio-filter" type="radio" onClick={()=>{props.fetchPosCreditsByDetails("30");}} name="dateFilterRadios" value="30" checked={props.input.value === '30'} />
            30 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '90')}>
        <div className="radio">
          <label htmlFor="ninetyDay-radio-filter">
            <input {...props.input} id="ninetyDay-radio-filter" type="radio" onClick={()=>{props.fetchPosCreditsByDetails("90");}} name="dateFilterRadios" value="90" checked={props.input.value === '90'} />
            90 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '-1')}>
        <div className="radio">
          <label htmlFor="dateRange-radio-filter">
            <input {...props.input} id="dateRange-radio-filter" type="radio" name="dateFilterRadios" value="-1" checked={props.input.value === '-1'} />
            <Translate value="date_range" />
          </label>
        </div>
      </Button>
      {renderStartDatePicker(props.Days)}
      {renderEndDatePicker(props.Days)}
      <Button
        bsStyle="primary"
        className="search-btn"
        type="submit"
        onClick={() => { props.fetchPosCreditsByDetails(); }}
      >
        <em className="fa fa-search" />
      </Button>
    </ButtonToolbar>
  );
};

const renderStatusRadios = (props) => {
  return (
    <ButtonToolbar className="radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, 'all')}>
        <div className="radio">
          <label htmlFor="all-radio-filter">
            <input {...props.input} id="all-radio-filter" type="radio" name="statusFilterRadios" value="all" checked={props.input.value === 'all'} />
            <Translate value="all" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Void')}>
        <div className="radio">
          <label htmlFor="void-radio-filter">
            <input {...props.input} id="void-radio-filter" type="radio" name="statusFilterRadios" value="Void" checked={props.input.value === 'Void'} />
            <Translate value="void" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  );
};

class PosCredits extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };
  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton,
      clear: true,
      posCredits: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      posCreditDetail: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      days: '1', // default on today
      action: null,
    };
    this.handleResize = this.handleResize.bind(this);
    this.fetchPosCreditsByDetails = this.fetchPosCreditsByDetails.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    const posCreditsFilter = this.props.posCreditsFilter;
    const route = 'posCredits'; // this.context.router.routes[1].path

    if (posCreditsFilter) {
      const selectedRows = posCreditsFilter.currentRows.filter((r) => {
        return r.isSelected === true;
      })
      const posCredits = { ...this.state.posCredits, rows: posCreditsFilter.currentRows, selectedRows, filters: {} }
      this.setState({ posCredits });
      this.props.setValue('posCredits', 'Days', posCreditsFilter.Days);
      this.props.setValue('posCredits', 'FromDate', posCreditsFilter.FromDate);
      this.props.setValue('posCredits', 'ToDate', posCreditsFilter.ToDate);
      this.props.setValue('posCredits', 'Seller', posCreditsFilter.Seller);
      this.props.setValue('posCredits', 'Status', posCreditsFilter.Status);
      let fromDate = '1900-01-01';
      if (posCreditsFilter.FromDate) {
        fromDate = this.formatDate(posCreditsFilter.FromDate);
      }
      let toDate = '3000-01-01';
      if (posCreditsFilter.ToDate) {
        toDate = this.formatDate(posCreditsFilter.ToDate);
      }
      this.props.fetchPosCreditsByFilter(fromDate, toDate, posCreditsFilter.Days, posCreditsFilter.Status, null, null, null, this.props.selectedCompany);
    } else {
      const fromDate = '1900-01-01';
      const toDate = '3000-01-01';
      const days = '1';
      const status = 'all'
      this.props.setValue('posCredits', 'Days', days);
      this.props.setDefaultOfForm('Status', 'all', 'posCredits');
      // this.props.fetchPosOrdersByFilter(fromDate, toDate, days, status);
    }
    if (posCreditsFilter && (route !== posCreditsFilter.currentPage)) {
      this.props.setSalesOrdersFilter(null);
    }
  }

  // Once products are ready, reset state.
  componentWillReceiveProps(nextProps) {
    const route = 'posCredits'; // this.context.router.routes[1].path;
    if (nextProps.posCredits && nextProps.posCredits !== this.props.posCredits) {
      if (this.props.posCreditsFilter
          && this.props.posCreditsFilter.currentRows
          && this.context.router.routes[1].path === this.props.posCreditsFilter.currentPage) {
        let posCredits = nextProps.posCredits;
        let rows = [...this.state.posCredits.rows];
        rows = rows.map((r) => {
          const index = _.findIndex(posCredits, { Order_id: r.Order_id });
          if (index > -1) {
            r.OrderDate = posCredits[index].OrderDate;
            r.DispatchDate = posCredits[index].DispatchDate;
            r.SaleStatus = posCredits[index].SaleStatus;
          } else {
            r = null;
          }
          return r;
        })
        rows = rows.filter((r) => {
          return r !== null;
        })
        const newPosCredits = { ...this.state.posCredits, rows };
        if (this.props.posCreditDetail) {
          const posCreditDetail = { ...this.state.posCreditDetail, rows: this.props.posCreditDetail };
          this.setState({ posCreditDetail });
        }
        this.setState({ posCredits: newPosCredits });
        // this.props.setSalesOrdersFilter(null);
      } else {
        const posCredits = { ...this.state.posCredits, rows: nextProps.posCredits, filters: {} };
        const posCreditDetail = { ...this.state.posCreditDetail, rows: [] };

        this.setState({ posCredits, posCreditDetail });
        // this.props.setSalesOrdersFilter(null);
      }
    }
    if (nextProps.posCreditDetail && nextProps.posCreditDetail !== this.props.posCreditDetail) {
      const posCreditDetail = { ...this.state.posCreditDetail, rows: nextProps.posCreditDetail };
      this.setState({ posCreditDetail });
    }

    if (nextProps.Status && nextProps.Status !== this.props.Status) {
      const posCreditsFilter = this.props.posCreditsFilter;
      if (!posCreditsFilter) {
        let seller = this.props.Seller
        if (this.props.Seller) {
          seller = this.props.Seller.value
        }
        const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
        const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
        let days = this.props.Days;

        if (days == null) {
          days = 1;
        }
        const productNum = this.props.ProductNum;
        this.props.fetchPosCreditsByFilter(fromDate, toDate, days, nextProps.Status, seller, productNum, route, this.props.selectedCompany);
      }
    }

    if (nextProps.Seller && nextProps.Seller !== this.props.Seller) {
      let posCreditsFilter = this.props.posCreditsFilter;
      if (!posCreditsFilter) {
        let seller = nextProps.Seller;
        if (nextProps.Seller) {
          seller = nextProps.Seller.value;
        }
        const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
        const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
        const days = this.props.Days;
        const productNum = this.props.ProductNum;
        this.props.fetchPosCreditsByFilter(fromDate, toDate, days, this.props.Status, seller, productNum, route, this.props.selectedCompany);
      }
    }

    if (this.props.Seller && nextProps.Seller == null) {
      const seller = nextProps.Seller;
      const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
      const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
      const days = this.props.Days;
      const productNum = this.props.ProductNum;
      this.props.fetchPosCreditsByFilter(fromDate, toDate, days, this.props.Status, seller, productNum, route, this.props.selectedCompany);
    }

    if (nextProps.Days && nextProps.Days !== this.props.Days) {
      if (nextProps.Days !== -1) {
        this.props.setDefaultOfForm('FromDate', null, 'posCredits');
        this.props.setDefaultOfForm('ToDate', null, 'posCredits');
      }
    }

    if ((isGFD || isCTP) && nextProps.selectedCompany && nextProps.selectedCompany !== this.props.selectedCompany) {
        let posCreditsFilter = this.props.posCreditsFilter;
        if (!posCreditsFilter) {
          let seller = this.props.Seller
          if (this.props.Seller) {
            seller = this.props.Seller.value
          }
          const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
          const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
          const days = this.props.Days;
          const productNum = this.props.ProductNum;
          this.props.fetchPosCreditsByFilter(fromDate, toDate, days, this.props.Status, seller, productNum, route, nextProps.selectedCompany);
      }
    }
  }

  componentDidUpdate() {
  }

  componentWillUnmount() {
    if (this.state.clear) {
      this.props.setSalesOrdersFilter(null);
    }
    window.removeEventListener('resize', this.handleResize);
  }

  fetchPosCreditsByDetails(value) {
    let dateRange = 7;
    let FromDate = '1900-01-01';
    let ToDate = '3000-01-01';
    let seller = this.props.Seller;
    const productNum = this.props.ProductNum;
    const route = 'posCredits'; // this.context.router.routes[1].path;
    if (this.props.FromDate !== null) { FromDate = this.formatDate(this.props.FromDate); }
    if (this.props.ToDate !== null) { ToDate = this.formatDate(this.props.ToDate); }
    if (this.props.Days !== null) { dateRange = this.props.Days; }
    if (value) {
      dateRange = value;
    }
    if (this.props.Seller) { seller = this.props.Seller.value; }

    // this.props.fetchSalesOrdersByFilter(FromDate, ToDate, dateRange, this.props.Status, seller, productNum, route);
    this.props.fetchPosCreditsByFilter(FromDate, ToDate, dateRange, this.props.Status, seller, productNum, route, this.props.selectedCompany);
  }

  formatDate(date) {
    let formattedDate = date.getFullYear() + '-';
    formattedDate += date.getMonth()+1 + '-';
    if (date.getDate() < 10) { formattedDate += '0' + date.getDate(); }
    else {formattedDate += date.getDate();}
    return formattedDate;
  }

  getUsers() {
    const Users = [];
    this.props.users.map((user) => {
      Users.push({ value: user.user_id, label: user.username });
    });
    return Users;
  }

  handleResize() {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton });
  }

  renderTable() {
    if (this.props.isLoading && !this.props.error) return <Spinner />
    else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>

    // Parameters of the react-data-grid
    const tableHeight = (window.innerHeight < 930) ? 270 : 270;

    const getRows = () => Data.Selectors.getRows(this.state.posCredits);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const onClearFilters = () => {
      // all filters removed
      const posCredits = { ...this.state.posCredits, filters: {} };
      this.setState({ posCredits });
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.posCredits, { sortColumn, sortDirection });
      this.setState({ posCredits: state });
    };

    const handleFilterChange = (filter) => {
      this.state.posCredits.rows = this.props.posCredits;
      this.state.posCredits.selectedRows = [];
      const newFilters = Object.assign({}, this.state.posCredits.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const posCredits = { ...this.state.posCredits, filters: newFilters };
      this.setState({ posCredits });
    };

    const onRowSelect = (rows) => {
      const posCredits = { ...this.state.posCredits, selectedRows: rows };
      this.setState({ posCredits });
    };

    const onCellSelected = (coordinates) => {
      const newRows = getRows();
      this.props.fetchPosCreditDetail(newRows[coordinates.rowIdx].Order_Num);

      /* Single row select on cell selected */
      newRows.map((r) => {
        r.isSelected = false;
      });
      const selectedRows = [newRows[coordinates.rowIdx]];
      newRows[coordinates.rowIdx].isSelected = true;
      const posCredits = { ...this.state.posCredits, rows: newRows, selectedRows };
      this.setState({ posCredits });
    };

    // Custom Formatter component
    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    // Column difinition
    const columns = [
      {
        key: 'Order_Num',
        name: <Translate value="order_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 135,
      },
      {
        key: 'Sales_User_Name',
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      {
        key: 'SaleStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 65,
        filterable: true,
      },
      {
        key: 'Date',
        name: <Translate value="date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: 'FinalPrice',
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'SalesMargin',
        name: <Translate value="sales_margin_percentsign" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: PercentFormatter,
      },
      {
        key: 'CreditCardAmount',
        name: <Translate value="credit_card_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'CheckAmount',
        name: <Translate value="check_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'CashAmount',
        name: <Translate value="cash_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'StoreCreditAmount',
        name: <Translate value="store_credit_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: 'MobileAmount',
        name: <Translate value="mobile_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
    ];

    return (
      // React Table Sales Order History Table
      <Row>
        <Col xs={12}>
          <div id="PosOrders-dataGrid1">
            <ReactDataGrid
              rowKey="PosOrder_id"
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter={true} />}
              onAddFilter={handleFilterChange}
              columns={columns}
              rowHeight={25}
              headerRowHeight={45}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              onClearFilters={onClearFilters}
              minHeight={tableHeight}
              enableRowSelect="single"
              rowSelection={{
                showCheckbox: true,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
              onRowSelect={onRowSelect}
              onCellSelected={onCellSelected}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderDatePickers() {
    if (this.props.Days === -1) {
      return (
        <div className="form-group date-picker-positioner">
          <label className="col-xs-2 from-label col-xs-offset-5"><Translate value="from" /></label>
          <div className="col-xs-2 control-date-picker">
            <Field name="FromDate" component={DatePicker} />
          </div>
          <label className="col-xs-1 to-label"><Translate value="to" /></label>
          <div className="col-xs-2 control-date-picker">
            <Field name="ToDate" component={DatePicker} />
          </div>
        </div>
      );
    }
  }

  renderUsers() {
    // If group is loading, show a spinner.
    if (this.props.usersIsLoading) return <Spinner />
    const Users = this.getUsers();
    return (
      <div className="control-dropdown">
        <Field name="Seller" component={Selection} options={Users} />
      </div>
    );
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderCreditTable() {
    if (this.props.posCreditIsLoading && !this.props.posCreditError) {
      return <Spinner />;
    } else if (this.props.posCreditError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.posCreditError)}
          </div>
        </ContentWrapper>
      );
    }

    const tableHeight = (window.innerHeight < 930) ? 185 : 185;

    const getRows = () => Data.Selectors.getRows(this.state.posCreditDetail);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.posCreditDetail, { sortColumn, sortDirection });
      this.setState({ posCreditDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const posCreditDetail = { ...this.state.posCreditDetail, filters: {} };
      this.setState({ posCreditDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.posCreditDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const posCreditDetail = { ...this.state.posCreditDetail, filters: newFilters };
      this.setState({ posCreditDetail });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const posCreditDetail = { ...this.state.posCreditDetail, selectedRows: rows };
      this.setState({ posCreditDetail });
    };

    // Custom Formatter component
    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value)
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    // Column definition
    const columns = [
      {
        key: 'UserName',
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: 'CreditInvoiceNum',
        name: <Translate value="credit_invoice_num" />,
        resizable: true,
        sortable: true,
        width: 200,
      },
      {
        key: 'ApplyAmount',
        name: <Translate value="apply_amount" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: 'RestAmount',
        name: <Translate value="rest_amount" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: 'SalesInvoiceNum',
        name: <Translate value="sales_invoice_num" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: 'CreateDatetime',
        name: <Translate value="date" />,
        resizable: true,
        sortable: true,
        formatter: DateFormatter,
        width: 150,
      },
    ];

    return (
      // Credit Invoice Details
      <Row>
        <Col xs={12}>
          <div id="PosOrders-dataGrid2">
            <ReactDataGrid
              rowKey="PosCredit_id"
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={tableHeight}
              onRowUpdated={this.handleRowUpdated}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    let posCredit_id = this.state.posCredits && this.state.posCredits.selectedRows[0] && this.state.posCredits.selectedRows[0].Order_id;
    posCredit_id = posCredit_id || '';
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="pos_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="pos_credits" />
          </Breadcrumb.Item>
        </Breadcrumb>
        {/* End Nav Trail */}

        <Grid id="sales-orders-list">
          <h1><Translate value="pos_credit_full_table" /></h1>

          {/* Order Type & Date Picker */}
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  <Col xs={1}>
                    <h3 className="filter-title"><Translate value="order_type" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={11}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      <Field name="Status" component={renderStatusRadios} />
                    </div>
                  </Col>
                  <Col xs={1}>
                    <h3 className="filter-title"><Translate value="date" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={11}>
                    <Field name="Days" component={renderRadios} fetchPosCreditsByDetails={this.fetchPosCreditsByDetails} Days={this.props.Days} />
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
          {/* End Order Type & Date Picker */}

          {/* Sales Order Full Table  */}
          <Row>
            <Col xs={12}>
              <Panel className="position-relative table-collapse-fix">
                {/* Sales Order Full Table */}
                {this.renderTable() }
              </Panel>
            </Col>
          </Row>
          {/* End Sales Order Full Table  */}

          {/* Sale Order Details */}
          <Row>
            <Col xs={12}>
              <h2><Translate value="pos_order_credits" /></h2>
              <Panel className="details-table-collapse-fix">
                {this.renderCreditTable()}
              </Panel>
            </Col>
          </Row>
          {/* End Sale Order Details */}
        </Grid>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default PosCredits;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/posCredits.jsx